import { SiteList } from '~/modules/sites';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(SiteList, t('menu.dashboard.settingsSites'));
